import { useIntegrations } from '@/hooks/integrations/useIntegrations'
import { useSyncIntegration } from '@/hooks/integrations/useSyncIntegration'
import { useSyncIntegrationStatus } from '@/hooks/integrations/useSyncIntegrationStatus'

import type { PaginatedResponse } from '@/types/Api'
import type { UUID } from '@/types/Id'
import type { Integration, SalesforceIntegration } from '@/types/Integration'

interface UseSalesforceIntegrationArgs {
  orgId: UUID | ''
}

const selectSalesforceIntegration = (
  data: PaginatedResponse<Integration>,
): SalesforceIntegration | undefined => {
  return data.data.find(
    (i): i is SalesforceIntegration => i.provider === 'salesforce',
  )
}

export const useSalesforceIntegration = ({
  orgId,
}: UseSalesforceIntegrationArgs) => {
  return useIntegrations({
    orgId,
    select: selectSalesforceIntegration,
  })
}

interface UseSyncSalesforceStatusArgs {
  orgId: UUID | ''
  onSuccess?: () => void
}

export const useSyncSalesforceStatusWithThrow = ({
  orgId,
  onSuccess,
}: UseSyncSalesforceStatusArgs) => {
  return useSyncIntegrationStatus({
    orgId,
    provider: 'salesforce',
    onSuccess,
  })
}

interface UseSyncSalesforceArgs {
  orgId: UUID | ''
}

export const useSyncSalesforceWithThrow = ({
  orgId,
}: UseSyncSalesforceArgs) => {
  return useSyncIntegration({
    orgId,
    provider: 'salesforce',
  })
}

interface UseHasSalesforceIntegrationArgs {
  orgId: UUID | ''
}

const selectHasSalesforceIntegration = (
  data: PaginatedResponse<Integration>,
) => {
  return data.data.some((i) => i.provider === 'salesforce')
}

export const useHasSalesforceIntegration = ({
  orgId,
}: UseHasSalesforceIntegrationArgs) => {
  return useIntegrations({
    orgId,
    select: selectHasSalesforceIntegration,
  })
}
